/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { TelemetryService } from './telemetry.js';

/**
 * No-op {@link TelemetryService} returned when telemetry is disabled (no
 * connection string, `enabled: false`, or test environment). Every method
 * returns synchronously without side effects.
 */
export const noopTelemetryService: TelemetryService = {
  trackEvent: () => undefined,
  trackException: () => undefined,
  trackPageView: () => undefined,
  flush: () => undefined,
};
